<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header1/>
    </div>
    <div style="height: 5em;"></div>
    <div class="user-agreement">
      <div class="box">
        <!-- Breadcrumbs -->
        <div class="Breadcrumbs">
          <div class="box">
            <a href='/' class=''>首页</a> &gt; <a href='/#/about' class=''>服务与支持</a> &gt; <a >用户协议</a>            </div>
        </div>
        <div class="tbox">
          <div class="title">用户协议</div>
          <div class="txt">
            <p>任何单位或个人在使用 Yasubit图像压缩服务之前，均应仔细阅读本条款，如不同意本条款可停止使用 Yasubit 的服务，一旦使用，即被视为对本条款全部内容的认可和接受。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;一、任何单位或个人通过 Yasubit 压缩的多媒体文件包括生成的临时URL链接，均系该用户或所有者制作提供（以下简称“第三方文件”）。Yasubit 只提供在线压缩和减少字节能力，并不是也不反映 Yasubit 之任何意见和主张，也不表示 Yasubit 同意或支持该等第三方文件的任何内容、主张或立场。Yasubit 对第三方文件中内容之合法性、准确性、真实性、适用性、安全性等概不负责，也无法负责。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;二、Yasubit 所提供的在线智能压缩能力不得不首先临时存储第三方文件，但 Yasubit 并不会长期存储第三方文件，任何单位或个人所提交/上传的全部文件，每隔60分钟自动删除，删除后文件链接既失效，请勿过渡依赖 Yasubit 所提供的文件链接。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;三、任何单位或个人不得利用 Yasubit 上传、压缩、下载、复制、发布、传播或者转载如下内容： &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;1、反对宪法所确定的基本原则的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;3、损害国家荣誉和利益的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;4、煽动民族仇恨、民族歧视，破坏民族团结的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;5、破坏国家宗教政策，宣扬邪教和封建迷信的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;6、散布谣言，扰乱社会秩序，破坏社会稳定的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;7、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;8、侮辱或者诽谤他人，侵害他人合法权益的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;9、含有法律、行政法规禁止的其他内容的信息。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;四、任何单位或个人如需要第三方文件中的内容（包括图片、音频、视频、文档、链接等），并欲据此进行交易或其他行为前，应慎重辨别这些内容的合法性、准确性、真实性、实用性和安全性（包括下载第三方文件中内容是否会感染电脑病毒），并采取谨慎的预防措施。如您不确定这些内容是否合法、准确、真实、实用和安全，Yasubit 建议您先咨询专业人士。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;五、任何单位或者个人因相信、使用第三方文件中信息、服务、产品等内容，或据此进行交易等行为，而引致的人身伤亡、财产毁损（包括因下载而感染电脑病毒）、名誉或商誉诽谤、版权或知识产权等权利的侵犯等事件，及因该等事件所造成的损害后果，Yasubit 概不负责，亦不会也不能承担任何法律责任，而应由第三方文件的所有者承担。无论何种原因，Yasubit 不对任何非与 Yasubit 直接发生的交易和行为承担任何直接、间接、附带或衍生的损失和责任。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;六、任何单位或个人如认为通过 Yasubit 服务所得的第三方文件中内容可能涉嫌侵害其合法著作权，应按照《信息网络传播权保护条例》的规定，以书面的形式及时向 Yasubit 反应，并提供相应身份证明、权属证明及详细的侵权情况证明，Yasubit 在收到上述文件后，会尽快断开对该内容的相关服务的链接。如果该等被断开链接的第三方文件所有者认为被提出权利主张的 Yasubit 结果并未侵害他人合法著作权的，亦有权按照《信息网络传播权保护条例》的规定，向 Yasubit 发出关于被断开链接不违反《信息网络传播权保护条例》的反通知。Yasubit 提醒您注意：如您的主张侵权或主张不侵权的陈述失实，您将按照《信息网络传播权保护条例》的规定，承担相关法律责任。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>

              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;七、Yasubit 可根据国家法律法规变化及维护用户权益需要，不时修改本条款，变更后的条款将通过法定程序在本条款中明显标注及注明最后的更新日期。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 八、充值后不予退还，请按需购买。<br/></p>            </div>
        </div>
      </div>

    </div>
    <Footer/>

  </div>
</template>
<script>
import Header1 from "@/views/header1.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header1,
    Banner,
    Footer
  },
  data() {
    return {
      isScrolled9: true,
      loading: true,
      caseList: []
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll9);
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
  },
  methods:
      {
        handleScroll9() {

          // 获取当前滚动位置
          const scrollY = window.scrollY || window.pageYOffset;

          // 可以设置一个阈值来确定何时改变isScrolled9的值
          const dis = 100;

          // 判断滚动位置是否大于阈值
          if (scrollY > dis) {
            // 向下滚动，将isScrolled9设为false
            this.isScrolled9 = false;
          } else {
            // 向上滚动，将isScrolled9设为true
            this.isScrolled9 = true;
          }

        },
      }
};
</script>

<style lang="scss" scoped>


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  //background-color: pink;
}


.one-third-1{
  width: 33.333333%;
  height: 15em;
  //background-color: pink;
}

.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>